export const NotFound: React.FC = () => {
  return (
    <div className="full-screen ion-text-center ion-padding">
      <div style={{fontSize:'4em'}}>😕</div>
      <h1>Not Found</h1>
      <p>Sorry, we couldn't find that page.</p>
    </div>
  );
};